here is a slide over panel